// Footer.tsx
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer
      className="footer"
      style={{
        borderTop: '1px solid #ddd',
        paddingTop: '10px',
        marginTop: '20px',
        fontSize: '12px',
        color: '#777',
        textAlign: 'center',
      }}
    >
      Página 1 de 1
    </footer>
  );
};

export default Footer;
